import CT from '@marketplace-ai/tags';
import { FormDialog, TableCard, Tabs } from '~/components';
import { CdsGrid, CdsLicenseForm } from './cds';
import { DeaGrid, DeaLicenseForm } from './dea';
import { useCdsService } from './hooks/useCdsService';
import { useDeaService } from './hooks/useDeaService';
import { useLicensesService } from './hooks/useLicensesService';
import { LICENSES_TABS } from './utils';

const DeaTab = () => {
  const { deaLicenses, loading, triggerAdd, handleEditClick, handleDeleteClick } = useDeaService();
  return (
    <TableCard
      mobilePageHeader
      title="DEA Licenses"
      addLabel="Add License"
      onAddClick={triggerAdd}
      addBtnTag={CT.account.licenses.dea.openCreateModal}
      layoutTag={CT.account.licenses.dea.table.layout}
    >
      <div className="h-[min(32.5rem,calc(100vh-22rem))] min-h-80">
        <DeaGrid
          handleDeleteClick={handleDeleteClick}
          handleEditClick={handleEditClick}
          loading={loading}
          deaLicenses={deaLicenses}
        />
      </div>
    </TableCard>
  );
};

const CdsTab = () => {
  const { cdsLicenses, loading, triggerAdd, handleEditClick, handleDeleteClick } = useCdsService();
  return (
    <TableCard
      mobilePageHeader
      title="CDS Licenses"
      addLabel="Add License"
      onAddClick={triggerAdd}
      addBtnTag={CT.account.licenses.cds.openCreateModal}
      layoutTag={CT.account.licenses.cds.table.layout}
    >
      <div className="h-[min(32.5rem,calc(100vh-22rem))] min-h-80">
        <CdsGrid
          handleDeleteClick={handleDeleteClick}
          handleEditClick={handleEditClick}
          loading={loading}
          cdsLicenses={cdsLicenses}
        />
      </div>
    </TableCard>
  );
};

const DeaFormContent = () => {
  const { deaLicenseForm, sendLicenseCreate, sendLicenseUpdate, onCancel } = useDeaService();
  const { modal } = useLicensesService();

  return (
    <DeaLicenseForm
      onCancel={onCancel}
      sendLicenseCreate={sendLicenseCreate}
      sendLicenseUpdate={sendLicenseUpdate}
      deaLicenseForm={deaLicenseForm}
      modal={modal}
    />
  );
};

const CdsFormContent = () => {
  const { cdsLicenseForm, sendLicenseCreate, sendLicenseUpdate, onCancel } = useCdsService();
  const { modal } = useLicensesService();

  return (
    <CdsLicenseForm
      onCancel={onCancel}
      sendLicenseCreate={sendLicenseCreate}
      sendLicenseUpdate={sendLicenseUpdate}
      cdsLicenseForm={cdsLicenseForm}
      modal={modal}
    />
  );
};

export const LicensesForm = () => {
  const { activeTab, modal, currentTabType, isDeaTab, handleTabChange, handleOnClose } =
    useLicensesService();

  return (
    <>
      <Tabs tabs={LICENSES_TABS} handleTabChange={handleTabChange} activeTab={activeTab} />
      {isDeaTab ? <DeaTab /> : <CdsTab />}
      <FormDialog
        title={currentTabType === 'dea' ? 'DEA License' : 'CDS License'}
        editing={modal.edit}
        creating={modal.create}
        onClose={handleOnClose}
      >
        {isDeaTab ? <DeaFormContent /> : <CdsFormContent />}
      </FormDialog>
    </>
  );
};
